import { createAction } from '@ngrx/store';

const loadUser = createAction('[Is Already Logged In Guard] Load user');

export const IsAlreadyLoggedInGuardActions = {
  loadUser,
};
